/** @format */

import { call, put, takeLatest } from 'redux-saga/effects';
import { sendFrilanceEmailService } from 'services/apiService';
import * as actionTypes from 'stateContainer/action-types';
import { push } from 'connected-react-router';

function* workerSaga({ payload }) {
  try {
    const response = yield call(sendFrilanceEmailService, payload);
    if (response.data.status == 'success') {
      yield put({
        type: actionTypes.SEND_FRILANCE_EMAIL_SUCCESS
      });
    } else {
      throw new Error('Login failed');
    }
  } catch (error) {
    yield put({ type: actionTypes.SEND_FRILANCE_EMAIL_ERROR, error });
    if (error.response.data.error == 'NotAuthorized') {
      yield put(push({ type: actionTypes.LOGOUT_REQUESTED }));
      yield put(push('/'));
    }
  }
}

export function* sendEmailSaga() {
  yield takeLatest(actionTypes.SEND_FRILANCE_EMAIL_REQUESTED, workerSaga);
}
